const FETCH_LANGUAGES_REQUEST = "FETCH_LANGUAGES_REQUEST";
const FETCH_LANGUAGES_SUCCESS = "FETCH_LANGUAGES_SUCCESS";
const FETCH_LANGUAGES_FAILURE = "FETCH_LANGUAGES_FAILURE";

export default {
  FETCH_LANGUAGES_REQUEST,
  FETCH_LANGUAGES_SUCCESS,
  FETCH_LANGUAGES_FAILURE,
};
